import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'olive-light';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FFF8F0]',
    white: 'bg-white',
    'olive-light': 'bg-[#F4F6F3]'
  };
  return <section id={id} className={`${bgColors[background]} py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden`} data-id="element-113">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className={`max-w-3xl mx-auto ${className}`} data-id="element-114">
        {children}
      </motion.div>
    </section>;
}